<mat-form-field class="date-input-field" [ngClass]="{ 'input-error' : isError }">
  <input
    #dateInput
    matInput
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="openDatepicker()"
    [value]="control?.value?.chosenLabel || ''"
    [placeholder]="isPlaceholderShown ? ('MAIN.CHOOSE_DATE' | translate) : ''"
    (change)="handleInputChange($event)"
    autocomplete="off"
    id="cdkOverlayTrigger"
    [disabled]="control.disabled || isDisabled"
  />
</mat-form-field>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isDataPickerOpen">
  <ngx-daterangepicker-material
    [startDate]="startDate"
    [endDate]="endDate"
    [linkedCalendars]="true"
    [autoUpdateInput]="true"
    (choosedDate)="chooseDate($event)"
    (focus)="handleFocus()"
    [alwaysShowCalendars]="true"
    [keepCalendarOpeningWithRange]="isRange"
    [locale]="locale"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [ranges]="ranges"
    [singleDatePicker]="!isRange"
    [showClearButton]="true"
    [showCustomRangeLabel]="isRange"
    [showClearButton]="true"
    [showCustomRangeLabel]="isRange"
    [timePicker]="isWithTimePicker"
    [timePicker24Hour]="true"
    [closeOnAutoApply]="false"
  >
  </ngx-daterangepicker-material>
</ng-template>

<!-- [autoApply]="!noAutoApply && !isRange" removed from the settings to fix the time in date picker-->
